import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  trailers: [],
};

const TrailerSlice = createSlice({
  name: "trailer",
  initialState,
  reducers: {
    setTrailers: (state, { payload }) => {
      state.trailers = payload;
    },
  },
});

export const { setTrailers } = TrailerSlice.actions;
export default TrailerSlice.reducer;
